"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCardDataInformation = exports.getProceduresDataSelector = exports.getDataLayer = void 0;

var _iguazuRpc = require("iguazu-rpc");

var _reselect = require("reselect");

var _immutable = require("immutable");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var loadCardDataInformation = function loadCardDataInformation(dispatch, accountTokens) {
  var cardDataPayload = {
    accountTokens: accountTokens,
    cardNames: [],
    analyticsData: {
      benefitName: 'all',
      channel: 'web',
      locale: 'en_us'
    }
  };

  if (!accountTokens || !accountTokens.length) {
    return {
      status: 'complete',
      data: [],
      promise: Promise.resolve([])
    };
  }

  var _dispatch = dispatch((0, _iguazuRpc.queryProcedureResult)({
    procedureName: 'readLoyaltyBenefitsCardProductV1',
    args: _objectSpread({}, cardDataPayload),
    forcedFetch: false
  })),
      promise = _dispatch.promise;

  return promise.then(function (_ref) {
    var cardDetails = _ref.cardDetails;
    var _cardDetails$ = cardDetails[0],
        cardName = _cardDetails$.cardName,
        accountToken = _cardDetails$.accountToken;
    var benefitsPayload = {
      cardProductName: cardName,
      accountToken: accountToken,
      analyticsData: _objectSpread({}, cardDataPayload.analyticsData)
    };
    return dispatch((0, _iguazuRpc.queryProcedureResult)({
      procedureName: 'readLoyaltyBenefitsV1',
      args: _objectSpread({}, benefitsPayload),
      forcedFetch: false
    }));
  }).catch(console.error);
};

exports.loadCardDataInformation = loadCardDataInformation;

var getProceduresDataSelector = function getProceduresDataSelector(state, props) {
  return (0, _immutable.fromJS)(state).getIn(['modules', props.MODULE_NAME, 'procedures']);
};

exports.getProceduresDataSelector = getProceduresDataSelector;
var getDataLayer = (0, _reselect.createSelector)([getProceduresDataSelector], function (state) {
  var procedureMap = state.getIn(['procedureCaches', 'readLoyaltyBenefitsV1'], new _immutable.Map());
  var keys = Array.from(procedureMap.keys());
  return procedureMap.get(keys[keys.length - 1]);
});
exports.getDataLayer = getDataLayer;